export default {
  tenants: (state) => state.tenants,
  tenant: (state) => state.tenant,
  notifications: (state) => state.notifications,
};
